import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import Wave from './ui/wave';
const AnimatedTagline = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, {
      threshold: 0.3
    });
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);
  return <section className="relative py-12 sm:py-16 overflow-hidden">
      {/* White background */}
      <div className="absolute inset-0 bg-white z-0"></div>
      
      <div className="container mx-auto px-4 sm:px-6 md:px-10 relative z-20" ref={containerRef}>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="max-w-4xl mx-auto text-center">
          <motion.h3 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.5
        }} className="text-xl sm:text-2xl font-display mb-6 font-bold text-gold-dark md:text-4xl">Build Smarter, Scale Faster — Without Breaking the Bank</motion.h3>
          
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            {['Automation', 'Efficiency', 'Growth', 'Innovation', 'Simplicity'].map((word, index) => <motion.span key={word} className="inline-block px-4 py-2 rounded-full border border-gold/30 text-gold text-xs sm:text-sm" initial={{
            opacity: 0,
            scale: 0.8
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.8 + index * 0.15,
            type: "spring",
            stiffness: 100
          }}>
                {word}
              </motion.span>)}
          </div>
        </motion.div>
      </div>
      
      {/* Wave at the bottom */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <Wave color="#c8a87d" height={50} />
      </div>
    </section>;
};
export default AnimatedTagline;